/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_EmptyInputs */

const en_issue_not_empty = /** @type {(inputs: Issue_Not_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`at least one is needed`)
};

/**
* | output |
* | --- |
* | "at least one is needed" |
*
* @param {Issue_Not_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_empty = /** @type {((inputs?: Issue_Not_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_empty(inputs)
});